var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaxonomy = function SvgTaxonomy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "var(--sidebar-menu-item-color)",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240zm-80-80v-560H200v560zm160-320v-320h240q33 0 56.5 23.5T840-760v240zm80-80h160v-160H600zm-80 480v-320h320v240q0 33-23.5 56.5T760-120zm80-80h160v-160H600zm0-160"
  })));
};
export default SvgTaxonomy;